import { render, staticRenderFns } from "./notiList.vue?vue&type=template&id=1e4a3fd8&scoped=true&"
import script from "./notiList.vue?vue&type=script&lang=js&"
export * from "./notiList.vue?vue&type=script&lang=js&"
import style0 from "./notiList.vue?vue&type=style&index=0&id=1e4a3fd8&scoped=true&lang=css&"
import style1 from "./notiList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4a3fd8",
  null
  
)

export default component.exports